(function () {
  'use strict';

  var SAVE_KEY = 'laki:saved-products';
  var drawerReady = false;
  var cssInjected = false;

  function injectCSS() {
    if (cssInjected) return;
    var s = document.createElement('style');
    s.id = 'sid-styles';
    s.textContent = '.sid-overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:900;opacity:0;visibility:hidden;transition:opacity .28s ease,visibility .28s ease}.sid-overlay.is-open{opacity:1;visibility:visible}.sid-drawer{position:fixed;top:0;right:0;bottom:80px;width:420px;max-width:100vw;background:#fff;z-index:901;display:flex;flex-direction:column;transform:translateX(100%);transition:transform .3s cubic-bezier(.25,.46,.45,.94);box-shadow:-4px 0 40px rgba(0,0,0,.16);outline:none;border-radius:0 0 0 10px}.sid-drawer.is-open{transform:translateX(0)}.sid-drawer__header{display:flex;align-items:center;justify-content:space-between;padding:0 18px;height:58px;border-bottom:1px solid #e8e8e2;flex-shrink:0;background:#fff}.sid-drawer__title{display:flex;align-items:center;gap:8px;font-size:15px;font-weight:700;color:#111;letter-spacing:-.01em}.sid-drawer__title-icon{color:#d00;flex-shrink:0}.sid-count-badge{display:inline-flex;align-items:center;justify-content:center;background:#111;color:#fff;font-size:10px;font-weight:700;min-width:17px;height:17px;border-radius:99px;padding:0 4px;line-height:1}.sid-close-btn{display:flex;align-items:center;justify-content:center;width:34px;height:34px;border:1px solid #e5e5e5;border-radius:50%;background:transparent;cursor:pointer;color:#666;transition:background .15s,color .15s;flex-shrink:0}.sid-close-btn:hover{background:#f5f5f5;color:#111}.sid-alert{display:flex;align-items:flex-start;gap:9px;padding:12px 14px;background:#fffbeb;border-bottom:1px solid #fde68a;flex-shrink:0}.sid-alert__icon{color:#d97706;flex-shrink:0;margin-top:1px}.sid-alert__body{flex:1;min-width:0}.sid-alert__text{font-size:12px;color:#78350f;margin:0 0 8px;line-height:1.5}.sid-alert__text strong{color:#92400e;font-weight:600}.sid-alert__email-btn{display:inline-flex;align-items:center;gap:5px;font-size:11.5px;font-weight:600;color:#92400e;background:transparent;border:1px solid #d97706;border-radius:5px;padding:5px 10px;cursor:pointer;transition:background .15s;line-height:1}.sid-alert__email-btn:hover{background:#fef3c7}.sid-email-panel{padding:13px 14px;background:#f9fafb;border-bottom:1px solid #e5e7eb;flex-shrink:0}.sid-email-panel__label{font-size:12px;color:#6b7280;margin:0 0 10px;line-height:1.5}.sid-share-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px}.sid-share-opt{display:flex;align-items:center;justify-content:center;gap:7px;height:40px;border-radius:7px;border:1px solid #e5e7eb;background:#fff;font-size:13px;font-weight:600;cursor:pointer;text-decoration:none;color:#111;transition:background .15s,border-color .15s;line-height:1}.sid-share-opt:hover{background:#f0f0ec;border-color:#d1d5db;text-decoration:none;color:#111}.sid-share-opt--copy{color:#374151}.sid-share-opt--copy.is-copied{background:#ecfdf5;border-color:#6ee7b7;color:#059669}.sid-body{flex:1;overflow-y:auto;overscroll-behavior:contain;-webkit-overflow-scrolling:touch}.sid-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:60px 24px;text-align:center;min-height:100%}.sid-empty[hidden]{display:none!important}.sid-empty__icon{color:#d4d4d4;margin-bottom:18px}.sid-empty__msg{font-size:17px;font-weight:700;color:#111;margin:0 0 8px}.sid-empty__sub{font-size:13px;color:#9ca3af;margin:0;line-height:1.5}.sid-list{list-style:none;margin:0;padding:0}.sid-card{display:flex;align-items:flex-start;gap:12px;padding:14px;border-bottom:1px solid #f0f0ec;position:relative;transition:background .12s;animation:sid-fade-in .2s ease forwards}.sid-card:last-child{border-bottom:none}.sid-card:hover{background:#fafaf8}@keyframes sid-fade-in{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:translateY(0)}}.sid-card__img-wrap{flex-shrink:0;width:82px;height:82px;border-radius:8px;overflow:hidden;border:1px solid #e8e8e2;background:#f5f5f3;display:block;text-decoration:none}.sid-card__img{width:100%;height:100%;object-fit:cover;display:block}.sid-card__img-ph{width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:#d4d4d4}.sid-card__info{flex:1;min-width:0;padding-right:30px}.sid-card__title{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:13px;font-weight:600;color:#111;text-decoration:none;line-height:1.4;margin-bottom:5px;display:block}.sid-card__title:hover{text-decoration:underline}.sid-card__price{display:flex;align-items:baseline;gap:6px;margin-bottom:10px}.sid-card__price-now{font-size:14px;font-weight:700;color:#111}.sid-card__price-now--sale{color:#dc2626}.sid-card__price-was{font-size:12px;color:#9ca3af;text-decoration:line-through}.sid-card__atc{width:100%;height:33px;background:#111;color:#fff;border:none;border-radius:5px;font-size:12px;font-weight:600;cursor:pointer;transition:background .15s;letter-spacing:.01em}.sid-card__atc:hover:not(:disabled){background:#333}.sid-card__atc:disabled{background:#9ca3af;cursor:not-allowed}.sid-card__atc.sid-atc--adding{background:#374151}.sid-card__atc.sid-atc--added{background:#059669}.sid-card__atc.sid-atc--error{background:#dc2626}.sid-card__remove{position:absolute;top:11px;right:10px;width:27px;height:27px;display:flex;align-items:center;justify-content:center;background:transparent;border:none;cursor:pointer;color:#b0b0a8;border-radius:50%;transition:background .15s,color .15s}.sid-card__remove:hover{background:#fee2e2;color:#dc2626}.sid-drawer__footer{padding:13px 14px;border-top:1px solid #e8e8e2;flex-shrink:0;text-align:center;background:#fff}.sid-clear-btn{font-size:12px;color:#9ca3af;background:none;border:none;cursor:pointer;text-decoration:underline;transition:color .15s;padding:0}.sid-clear-btn:hover{color:#dc2626}.sid-trigger{position:relative}.sid-trigger__badge{position:absolute;top:-2px;right:-2px;min-width:15px;height:15px;background:#e10000;color:#fff;border-radius:99px;font-size:9.5px;font-weight:700;display:flex;align-items:center;justify-content:center;padding:0 3px;pointer-events:none;line-height:1;border:1.5px solid var(--header-main-background,#000)}#sid-drawer [hidden]{display:none!important}@media(max-width:480px){.sid-drawer{width:100vw;bottom:0;border-radius:0}}';
    document.head.appendChild(s);
    cssInjected = true;
  }

  // ── Storage helpers ───────────────────────────────────────────────────────
  function readSaved() {
    try {
      var raw = localStorage.getItem(SAVE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }

  function writeSaved(list) {
    try { localStorage.setItem(SAVE_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function getItemId(item) {
    return typeof item === 'string' ? item : String(item.id || '');
  }

  // ── Price formatter ───────────────────────────────────────────────────────
  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    var c = parseInt(cents, 10);
    var amount = (c / 100).toFixed(2);
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    return fmt
      .replace(/\{\{amount\}\}/, amount)
      .replace(/\{\{amount_no_decimals\}\}/, Math.round(c / 100))
      .replace(/\{\{amount_with_comma_separator\}\}/, amount.replace('.', ','))
      .replace(/\{\{amount_no_decimals_with_comma_separator\}\}/, Math.round(c / 100));
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  // ── Header elements (always in DOM) ──────────────────────────────────────
  var trigger      = document.getElementById('sid-trigger');
  var triggerBadge = document.getElementById('sid-trigger-badge');

  // ── Drawer elements (assigned after lazy injection) ───────────────────────
  var overlay, drawer, closeBtn, countBadge;
  var emailToggle, emailPanel;
  var optGmail, optOutlook, optYahoo, optCopy, copyLabel;
  var listEl, emptyEl, footerEl, clearAllBtn;

  // ── Lazy inject from <template> ───────────────────────────────────────────
  function injectDrawer() {
    if (drawerReady) return true;
    var tpl = document.getElementById('sid-drawer-template');
    if (!tpl) return false;
    document.body.appendChild(tpl.content.cloneNode(true));

    overlay     = document.getElementById('sid-overlay');
    drawer      = document.getElementById('sid-drawer');
    closeBtn    = document.getElementById('sid-close');
    countBadge  = document.getElementById('sid-count-badge');
    emailToggle = document.getElementById('sid-email-toggle');
    emailPanel  = document.getElementById('sid-email-panel');
    optGmail    = document.getElementById('sid-opt-gmail');
    optOutlook  = document.getElementById('sid-opt-outlook');
    optYahoo    = document.getElementById('sid-opt-yahoo');
    optCopy     = document.getElementById('sid-opt-copy');
    copyLabel   = document.getElementById('sid-copy-label');
    listEl      = document.getElementById('sid-list');
    emptyEl     = document.getElementById('sid-empty');
    footerEl    = document.getElementById('sid-footer');
    clearAllBtn = document.getElementById('sid-clear-all');

    bindDrawerEvents();
    drawerReady = true;
    return true;
  }

  // ── Open / close ──────────────────────────────────────────────────────────
  function openDrawer() {
    injectCSS();
    if (!injectDrawer()) return;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    overlay.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    window.theme?.trapFocus(drawer);
    drawer.focus();
    render();
  }

  function closeDrawer() {
    if (!drawer) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.theme?.releaseFocus(drawer);
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }
  }

  if (trigger) trigger.addEventListener('click', openDrawer);

  // Global trigger — any element with data-sid-open opens the drawer (e.g. footer nav links)
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-sid-open]');
    if (!opener) return;
    e.preventDefault();
    openDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  // ── Bind all drawer-internal events after injection ───────────────────────
  function bindDrawerEvents() {
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay)  overlay.addEventListener('click', closeDrawer);

    if (emailToggle) {
      emailToggle.addEventListener('click', function () {
        if (emailPanel.hasAttribute('hidden')) {
          emailPanel.removeAttribute('hidden');
          updateShareLinks();
        } else {
          emailPanel.setAttribute('hidden', '');
        }
      });
    }

    if (optCopy) {
      optCopy.addEventListener('click', function () {
        var payload = buildSharePayload();
        if (!payload) return;
        var text = payload.body;
        function onCopied() {
          if (copyLabel) copyLabel.textContent = '✓ Copied!';
          optCopy.classList.add('is-copied');
          setTimeout(function () {
            if (copyLabel) copyLabel.textContent = 'Copy list';
            optCopy.classList.remove('is-copied');
          }, 2200);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(onCopied).catch(onCopied);
        } else {
          var ta = document.createElement('textarea');
          ta.value = text;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          onCopied();
        }
      });
    }

    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', function () {
        writeSaved([]);
        window.dispatchEvent(new CustomEvent('laki:saved-updated'));
        render();
      });
    }
  }

  // ── Share payload builder ─────────────────────────────────────────────────
  function buildSharePayload() {
    var saved = readSaved();
    if (!saved.length) return null;
    var shopHost = window.location.origin;
    var rawTitle = document.title || '';
    var shopName = (rawTitle.split(' – ').pop() || rawTitle.split(' - ').pop() || rawTitle).trim() || shopHost;
    var subject  = 'My Saved Items from ' + shopName;
    var body     = 'Hi,\n\nHere are the items I saved:\n\n';
    saved.forEach(function (item, i) {
      if (typeof item === 'string') {
        body += (i + 1) + '. Product (ID: ' + item + ')\n   Visit the store to view.\n\n';
      } else {
        var price = item.price ? formatMoney(item.price) : '';
        body += (i + 1) + '. ' + (item.title || 'Product');
        if (price) body += ' — ' + price;
        body += '\n';
        if (item.url) body += '   ' + shopHost + item.url + '\n';
        body += '\n';
      }
    });
    body += 'Shop now at ' + shopHost;
    var s = encodeURIComponent(subject);
    var b = encodeURIComponent(body);
    return {
      body:    body,
      gmail:   'https://mail.google.com/mail/?view=cm&su=' + s + '&body=' + b,
      outlook: 'https://outlook.live.com/mail/0/deeplink/compose?subject=' + s + '&body=' + b,
      yahoo:   'https://compose.mail.yahoo.com/?subject=' + s + '&body=' + b
    };
  }

  function updateShareLinks() {
    var p = buildSharePayload();
    if (!p) return;
    if (optGmail)   optGmail.href   = p.gmail;
    if (optOutlook) optOutlook.href = p.outlook;
    if (optYahoo)   optYahoo.href   = p.yahoo;
  }

  // ── Badge update ──────────────────────────────────────────────────────────
  function updateBadge() {
    var count = readSaved().length;
    if (triggerBadge) {
      triggerBadge.textContent = count;
      count > 0 ? triggerBadge.removeAttribute('hidden') : triggerBadge.setAttribute('hidden', '');
    }
    if (countBadge) {
      countBadge.textContent = count;
      count > 0 ? countBadge.removeAttribute('hidden') : countBadge.setAttribute('hidden', '');
    }
  }

  // ── Render product list ───────────────────────────────────────────────────
  function render() {
    if (!listEl) return;
    var saved = readSaved();
    updateBadge();

    if (!saved.length) {
      listEl.innerHTML = '';
      emptyEl.removeAttribute('hidden');
      footerEl.setAttribute('hidden', '');
      return;
    }

    emptyEl.setAttribute('hidden', '');
    footerEl.removeAttribute('hidden');

    var html = '';
    saved.forEach(function (item) {
      var id = getItemId(item);

      if (typeof item === 'string') {
        html += '<li class="sid-card" data-saved-id="' + esc(id) + '">' +
          '<div class="sid-card__img-wrap"><div class="sid-card__img-ph">' + phSvg() + '</div></div>' +
          '<div class="sid-card__info"><span class="sid-card__title" style="color:#9ca3af">Product unavailable — please re-save from the product page</span></div>' +
          removeBtnHtml(id, 'item') +
        '</li>';
        return;
      }

      var imgHtml = item.image
        ? '<img class="sid-card__img" src="' + esc(item.image) + '" alt="' + esc(item.title || '') + '" loading="lazy">'
        : '<div class="sid-card__img-ph">' + phSvg() + '</div>';

      var onSale = item.comparePrice && parseInt(item.comparePrice, 10) > parseInt(item.price || 0, 10);
      var priceHtml = item.price
        ? '<div class="sid-card__price">' +
            '<span class="sid-card__price-now' + (onSale ? ' sid-card__price-now--sale' : '') + '">' + esc(formatMoney(item.price)) + '</span>' +
            (onSale ? '<span class="sid-card__price-was">' + esc(formatMoney(item.comparePrice)) + '</span>' : '') +
          '</div>'
        : '';

      var atcHtml = item.variantId
        ? '<button type="button" class="sid-card__atc" data-sid-atc data-variant-id="' + esc(item.variantId) + '">Add to Cart</button>'
        : '';

      var url = item.url || '#';

      html += '<li class="sid-card" data-saved-id="' + esc(id) + '">' +
        '<a class="sid-card__img-wrap" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' + imgHtml + '</a>' +
        '<div class="sid-card__info">' +
          '<a class="sid-card__title" href="' + esc(url) + '">' + esc(item.title || 'Product') + '</a>' +
          priceHtml + atcHtml +
        '</div>' +
        removeBtnHtml(id, item.title || 'item') +
      '</li>';
    });

    listEl.innerHTML = html;
    bindCardEvents();
    verifyLinks(saved);
  }

  // ── Self-healing: prune entries whose product URL no longer resolves
  // (deleted/unpublished product, or stale localStorage left over from
  // browsing a different store on the same browser profile). Only runs for
  // the handful of items visible when the drawer is opened, never on page
  // load, and only prunes on a confirmed 4xx/5xx response — network errors
  // (e.g. offline) leave the item alone. ──────────────────────────────────
  function verifyLinks(saved) {
    saved.forEach(function (item) {
      if (typeof item === 'string' || !item.url) return;
      var id = getItemId(item);
      fetch(item.url, { method: 'HEAD' })
        .then(function (res) {
          if (!res.ok) pruneStaleEntry(id);
        })
        .catch(function () {});
    });
  }

  function pruneStaleEntry(id) {
    var remaining = readSaved().filter(function (item) { return getItemId(item) !== id; });
    writeSaved(remaining);
    window.dispatchEvent(new CustomEvent('laki:saved-updated'));

    var card = listEl && listEl.querySelector('[data-saved-id="' + id + '"]');
    if (!card) return;
    card.style.transition = 'opacity .2s ease';
    card.style.opacity = '0';
    setTimeout(function () {
      card.remove();
      if (listEl && !listEl.children.length) render();
    }, 200);
  }

  function phSvg() {
    return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="m3 9 4-4 4 4 4-4 4 4"/><circle cx="8" cy="14" r="1.5"/></svg>';
  }

  function removeBtnHtml(id, title) {
    return '<button type="button" class="sid-card__remove" data-sid-remove data-saved-id="' + esc(id) + '" aria-label="Remove ' + esc(title) + ' from saved items">' +
      '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
    '</button>';
  }

  // ── Card event bindings ───────────────────────────────────────────────────
  function bindCardEvents() {
    listEl.querySelectorAll('[data-sid-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.dataset.savedId;
        var updated = readSaved().filter(function (item) { return getItemId(item) !== id; });
        writeSaved(updated);
        window.dispatchEvent(new CustomEvent('laki:saved-updated'));
        var card = listEl.querySelector('[data-saved-id="' + id + '"]');
        if (card) {
          card.style.transition = 'opacity .2s, transform .2s';
          card.style.opacity = '0';
          card.style.transform = 'translateX(16px)';
          setTimeout(render, 220);
        } else {
          render();
        }
      });
    });

    listEl.querySelectorAll('[data-sid-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        if (!variantId) return;
        btn.disabled = true;
        btn.classList.add('sid-atc--adding');
        btn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
        .then(function (r) {
          // /cart/add.js still returns a parseable JSON body on failure
          // (e.g. 422 for a sold-out or no-longer-existing variant) — it
          // doesn't reject the fetch promise. Checking r.ok here is what
          // actually was missing: without it, an error response fell
          // straight through to the "success" branch below and showed
          // "Added!" even though nothing was added to the cart.
          return r.json().then(function (data) {
            if (!r.ok) {
              var err = new Error(data.description || data.message || 'Unable to add this item.');
              err.status = r.status;
              throw err;
            }
            return data;
          });
        })
        .then(function () {
          btn.classList.remove('sid-atc--adding');
          btn.classList.add('sid-atc--added');
          btn.textContent = '✓ Added!';
          if (window.theme && window.theme.refreshCartDrawer) {
            window.theme.refreshCartDrawer({ open: true });
          } else {
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var badge = document.querySelector('[data-cart-count]');
                if (badge) badge.textContent = cart.item_count;
                document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
              });
          }
          setTimeout(function () {
            btn.disabled = false;
            btn.classList.remove('sid-atc--added');
            btn.textContent = 'Add to Cart';
          }, 2200);
        })
        .catch(function (err) {
          btn.classList.remove('sid-atc--adding');
          btn.classList.add('sid-atc--error');
          btn.textContent = 'Unavailable';
          setTimeout(function () {
            btn.disabled = false;
            btn.classList.remove('sid-atc--error');
            btn.textContent = 'Add to Cart';
          }, 2200);

          // A 404 here means the saved variant ID no longer exists at all
          // (deleted, or — the original reason this was added — stale
          // localStorage from a different store on the same browser
          // profile) rather than just being sold out. Prune it the same
          // way a dead product link gets pruned.
          if (err && err.status === 404) {
            var card = btn.closest('[data-saved-id]');
            if (card) pruneStaleEntry(card.dataset.savedId);
          }
        });
      });
    });
  }

  // ── External updates ──────────────────────────────────────────────────────
  window.addEventListener('laki:saved-updated', function () {
    updateBadge();
    if (drawer && drawer.classList.contains('is-open')) render();
  });

  // ── Init ──────────────────────────────────────────────────────────────────
  updateBadge();

})();
